import axiosInstance from "./global-instance";
import createScopedApi from "./createScopedApi";
import { inHouseApiUrl } from "../constants/url-constants";

const BASE_API_URL = `${inHouseApiUrl()}/api`;

export default createScopedApi(BASE_API_URL, axiosInstance);
